import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Search, Calendar, Tag, ArrowRight, ChevronRight } from 'lucide-react';
export const Insights = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const categories = [{
    id: 'all',
    name: 'All Posts'
  }, {
    id: 'strategy',
    name: 'Strategy'
  }, {
    id: 'business',
    name: 'Business'
  }, {
    id: 'innovation',
    name: 'Innovation'
  }, {
    id: 'africa',
    name: 'African Markets'
  }];
  const featuredPost = {
    id: 1,
    title: 'The Future of African Business Innovation in a Global Context',
    excerpt: 'Exploring how African businesses are leveraging unique approaches to innovation and creating competitive advantages in the global marketplace.',
    image: 'https://images.unsplash.com/photo-1539037116277-4db20889f2d4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
    date: 'October 15, 2023',
    category: 'innovation',
    readTime: '8 min read'
  };
  const posts = [{
    id: 2,
    title: 'Strategic Planning for Small Businesses: A Guide for African Entrepreneurs',
    excerpt: 'Essential strategic planning techniques tailored for small business owners across Africa.',
    image: 'https://images.unsplash.com/photo-1504589807621-89f8cf8db7b8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
    date: 'October 5, 2023',
    category: 'strategy',
    readTime: '6 min read'
  }, {
    id: 3,
    title: 'Building Resilient Business Models in Emerging Markets',
    excerpt: 'How to create adaptable business models that can thrive despite market volatility and infrastructure challenges.',
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1471&q=80',
    date: 'September 28, 2023',
    category: 'business',
    readTime: '7 min read'
  }, {
    id: 4,
    title: 'Cross-Border Expansion: Navigating Regulatory Challenges in Africa',
    excerpt: 'A comprehensive guide to understanding and overcoming regulatory hurdles when expanding across African markets.',
    image: 'https://images.unsplash.com/photo-1581056771107-24ca5f033842?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
    date: 'September 15, 2023',
    category: 'africa',
    readTime: '9 min read'
  }, {
    id: 5,
    title: 'Digital Transformation Strategies for Traditional Businesses',
    excerpt: 'How established businesses can successfully integrate digital technologies to remain competitive.',
    image: 'https://images.unsplash.com/photo-1542744094-24638eff58bb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1469&q=80',
    date: 'September 5, 2023',
    category: 'innovation',
    readTime: '5 min read'
  }, {
    id: 6,
    title: 'Sustainable Business Practices in the African Context',
    excerpt: 'Exploring how sustainability can be a competitive advantage for African businesses.',
    image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
    date: 'August 25, 2023',
    category: 'africa',
    readTime: '7 min read'
  }];
  const filteredPosts = activeCategory === 'all' ? posts : posts.filter(post => post.category === activeCategory);
  return <div className="w-full min-h-screen bg-white" data-id="element-440">
      <Header data-id="element-441" />
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 pt-24 pb-16 md:pt-32 md:pb-24" data-id="element-442">
        <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-443"></div>
        <div className="container mx-auto px-4 text-center" data-id="element-444">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-445">
            Insights & <span className="text-amber-400" data-id="element-446">Knowledge</span>
          </h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto mb-8" data-id="element-447">
            Expert analysis, industry trends, and strategic perspectives to help
            African and Diasporan businesses thrive in today's dynamic
            marketplace.
          </p>
          {/* Search */}
          <div className="max-w-md mx-auto relative" data-id="element-448">
            <input type="text" placeholder="Search insights..." className="w-full px-5 py-3 pl-12 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-449" />
            <Search className="absolute left-4 top-3.5 text-gray-400" size={18} data-id="element-450" />
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-white" style={{
        clipPath: 'polygon(0 100%, 100% 100%, 100% 0)'
      }} data-id="element-451"></div>
      </section>
      {/* Categories */}
      <section className="py-8 border-b" data-id="element-452">
        <div className="container mx-auto px-4" data-id="element-453">
          <div className="flex flex-wrap items-center justify-center gap-3" data-id="element-454">
            {categories.map(category => <button key={category.id} className={`px-5 py-2 rounded-full text-sm font-medium transition ${activeCategory === category.id ? 'bg-blue-800 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setActiveCategory(category.id)} data-id="element-455">
                {category.name}
              </button>)}
          </div>
        </div>
      </section>
      {/* Featured Post */}
      <section className="py-12 bg-gray-50" data-id="element-456">
        <div className="container mx-auto px-4" data-id="element-457">
          <h2 className="text-2xl font-bold mb-8" data-id="element-458">Featured Insight</h2>
          <div className="bg-white rounded-lg shadow-lg overflow-hidden md:flex" data-id="element-459">
            <div className="md:w-1/2" data-id="element-460">
              <img src={featuredPost.image} alt={featuredPost.title} className="w-full h-64 md:h-full object-cover" data-id="element-461" />
            </div>
            <div className="md:w-1/2 p-6 md:p-8" data-id="element-462">
              <div className="flex items-center text-sm text-gray-500 mb-2" data-id="element-463">
                <Calendar size={16} className="mr-2" data-id="element-464" />
                <span data-id="element-465">{featuredPost.date}</span>
                <span className="mx-2" data-id="element-466">•</span>
                <Tag size={16} className="mr-2" data-id="element-467" />
                <span className="capitalize" data-id="element-468">{featuredPost.category}</span>
                <span className="mx-2" data-id="element-469">•</span>
                <span data-id="element-470">{featuredPost.readTime}</span>
              </div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-471">{featuredPost.title}</h3>
              <p className="text-gray-600 mb-6" data-id="element-472">{featuredPost.excerpt}</p>
              <a href={`/insights/${featuredPost.id}`} className="inline-flex items-center font-medium text-blue-800 hover:text-blue-700" data-id="element-473">
                Read Full Article
                <ArrowRight size={16} className="ml-2" data-id="element-474" />
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Posts Grid */}
      <section className="py-16" data-id="element-475">
        <div className="container mx-auto px-4" data-id="element-476">
          <h2 className="text-2xl font-bold mb-8" data-id="element-477">Latest Insights</h2>
          {filteredPosts.length > 0 ? <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-478">
              {filteredPosts.map(post => <div key={post.id} className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100" data-id="element-479">
                  <img src={post.image} alt={post.title} className="w-full h-48 object-cover" data-id="element-480" />
                  <div className="p-6" data-id="element-481">
                    <div className="flex items-center text-xs text-gray-500 mb-2" data-id="element-482">
                      <Calendar size={14} className="mr-1" data-id="element-483" />
                      <span data-id="element-484">{post.date}</span>
                      <span className="mx-2" data-id="element-485">•</span>
                      <span className="capitalize" data-id="element-486">{post.category}</span>
                      <span className="mx-2" data-id="element-487">•</span>
                      <span data-id="element-488">{post.readTime}</span>
                    </div>
                    <h3 className="text-xl font-bold mb-2" data-id="element-489">{post.title}</h3>
                    <p className="text-gray-600 mb-4 text-sm" data-id="element-490">{post.excerpt}</p>
                    <a href={`/insights/${post.id}`} className="inline-flex items-center text-sm font-medium text-blue-800 hover:text-blue-700" data-id="element-491">
                      Read More
                      <ChevronRight size={16} className="ml-1" data-id="element-492" />
                    </a>
                  </div>
                </div>)}
            </div> : <div className="text-center py-12" data-id="element-493">
              <p className="text-gray-500" data-id="element-494">No posts found in this category.</p>
            </div>}
        </div>
      </section>
      {/* Newsletter */}
      <section className="py-12 bg-blue-900 text-white" data-id="element-495">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-496">
          <div className="bg-blue-800 rounded-lg p-8 md:p-12 shadow-lg" data-id="element-497">
            <div className="text-center mb-8" data-id="element-498">
              <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-499">
                Stay Updated with Our Latest Insights
              </h3>
              <p className="text-blue-100" data-id="element-500">
                Join our newsletter to receive the latest insights, trends, and
                strategic advice directly in your inbox.
              </p>
            </div>
            <form className="max-w-md mx-auto" data-id="element-501">
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-502">
                <input type="email" placeholder="Your email address" className="flex-grow px-4 py-3 rounded-md focus:outline-none text-gray-800" data-id="element-503" />
                <button type="submit" className="bg-amber-500 hover:bg-amber-600 text-blue-900 font-medium px-6 py-3 rounded-md transition" data-id="element-504">
                  Subscribe
                </button>
              </div>
              <p className="text-xs text-blue-200 text-center mt-4" data-id="element-505">
                We respect your privacy. Unsubscribe at any time.
              </p>
            </form>
          </div>
        </div>
      </section>
      <Footer data-id="element-506" />
    </div>;
};